var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_circle"},[_c('div',{staticClass:"image_container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }